<template>
  <a-layout class="layout">
    <a-layout-content :class="[{'mobile-style': isMobile, 'pc-style': !isMobile}]">
      <a-breadcrumb style="margin: 16px 0">
      </a-breadcrumb>
      <div :style="{ background: '#fff', padding: '24px', minHeight: '280px' }">
        <a-menu v-model:selectedKeys="currentMenu" mode="horizontal" :items="items"/>

        <!--成功结果-->
        <a-result
            status="success"
            title="Congratulations!"
            sub-title="Your reward has been issued. Please check your account to confirm receipt."
            v-show="formState.process === 'approved' && formState.prize_type === 'CASH'"
        >
        </a-result>
        <a-result
            status="success"
            title="Congratulations!"
            :sub-title="'The free product has been shipped. Please track your package with this number: ' + formState.tracking_number"
            v-show="formState.process === 'approved' && formState.prize_type === 'PRODUCT'"
        >
        </a-result>

        <!--待审核-->
        <a-result title="Please wait for 3 days then check." v-show="formState.process === 'submitted'">
          <template #icon>
            <smile-twoTone />
          </template>
        </a-result>

        <!--审核驳回-->
        <a-result status="warning" title="We regret to inform you that the review was not approved."
            subTitle="Email: support@dealnewspaper.com    Phone: +1-866-228-4920 / +1-888-994-4669"
            v-show="formState.process === 'rejected'"
        >
        </a-result>

        <div class="example" v-show="!loading">
          <a-spin />
        </div>

        <a-form
            v-show="loading"
            :model="formState"
            name="basic"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 14 }"
            autocomplete="off"
            :style="{ padding: '40px', textAlign: 'left' }"
        >
          <a-form-item label="Process">
            <a-tag color="processing" v-if="['unverified', 'submitted'].includes(formState.process)">{{ formState.process_desc }}</a-tag>
            <a-tag color="success" v-else-if="formState.process === 'approved'">{{ formState.process_desc }}</a-tag>
            <a-tag color="warning" v-else-if="['verified', 'rejected'].includes(formState.process)">{{ formState.process_desc }}</a-tag>
            <a-tag color="default" v-else>{{ formState.process_desc }}</a-tag>
          </a-form-item>

          <a-form-item label="Reason for Rejection" v-if="formState.process === 'rejected'">
            <span class="ant-form-text" style="color: #faad14;"><b>{{ formState.rejection_reason ? formState.rejection_reason : 'The submission was not approved during review' }}</b></span>

            <a type="primary" :href="'/claim-prize?id=' + formState.record_id" style="color: #faad14;">
              <a-button type="primary">Resubmit</a-button>
            </a>
          </a-form-item>

          <a-form-item label="Code">
            <span class="ant-form-text">{{ formState.code }}</span>
          </a-form-item>
          <a-form-item label="Order Id">
            <span class="ant-form-text">{{ formState.order_id }}</span>
          </a-form-item>
          <a-form-item label="Contact Email">
            <span class="ant-form-text">{{ formState.email }}</span>
          </a-form-item>
          <a-form-item label="Phone">
            <span class="ant-form-text">{{ formState.phone }}</span>
          </a-form-item>
          <a-form-item label="Review Screenshot" v-show="!['unverified', 'rejected'].includes(formState.process)">
            <a-upload
                name="file"
                v-model:file-list="fileList"
                list-type="picture-card"
                @preview="handlePreview"
                accept="image/jpeg,image/png,image/jpg,image/gif"
                style="text-align: left"
            >
            </a-upload>
            <a-modal :open="previewVisible" :title="previewTitle" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage"/>
            </a-modal>
          </a-form-item>
          <a-form-item label="Payee account information" v-if="formState.prize_type === 'CASH' && !['unverified', 'rejected'].includes(formState.process)">
            <span class="ant-form-text">{{ formState.payment_info }}</span>
          </a-form-item>
          <a-form-item label="Delivery address" v-if="formState.prize_type === 'PRODUCT' && !['unverified', 'rejected'].includes(formState.process)">
            <span class="ant-form-text">{{ formState.address }}</span>
          </a-form-item>
          <a-form-item label="Tracking Number" v-if="formState.prize_type === 'PRODUCT' && !['unverified', 'rejected'].includes(formState.process)">
            <span class="ant-form-text">{{ formState.tracking_number }}</span>
          </a-form-item>
        </a-form>
      </div>
    </a-layout-content>
    <a-layout-footer style="text-align: center; height: 0px;">
    </a-layout-footer>
  </a-layout>
</template>

<script setup>
import {h, inject, onMounted, reactive, ref} from "vue";
import { useRoute } from 'vue-router';
import { SmileTwoTone } from '@ant-design/icons-vue';
import {claimDetail} from "@/services/claimPrize";
import {message} from "ant-design-vue"; // 待审核结果文字图标需要

const isMobile = inject('isMobile');
const showLogin = inject('showLogin');
showLogin.value = false;

const loading = ref(false);
const currentMenu = ref(['claim-history']);
const items = ref([
  {
    key: 'claim-prize',
    label: h(
        'a',
        {
          href: '/claim-prize',
        },
        'Claim Reward'
    ),
    title: 'Claim Reward',
  },
  {
    key: 'claim-history',
    label: h(
        'a',
        {
          href: '/claim-history',
        },
        'Claim History',
    ),
    title: 'Claim History',
  },
]);


const formState = reactive({
  'record_id': '',
  'code': '',
  'prize_type': '',
  'order_id': '',
  'email': '',
  'phone': '',
  'imageList': [],
  'payment_info': '',
  'prize_claim_time': '',
  'process': '',
  'address': '',
  'tracking_number': '',
  'process_desc': '',
  'rejection_reason': '',
});

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
const previewVisible = ref(false);
const previewImage = ref('');
const previewTitle = ref('');
const fileList = ref([]);
const handleCancel = () => {
  previewVisible.value = false;
  previewTitle.value = '';
};
const handlePreview = async file => {
  if (!file.url && !file.preview) {
    file.preview = await getBase64(file.originFileObj);
  }
  previewImage.value = file.url || file.preview;
  previewVisible.value = true;
  previewTitle.value = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
};


const queryData = async params => {
  console.log('===params', params)
  const res = await claimDetail(params);
  console.log('===query res', res);
  if (typeof res !== 'undefined' && res.code === 200) {
    loading.value = true;

    formState.code = res.data.code;
    formState.prize_type = res.data.prize_type;
    formState.order_id = res.data.order_id;
    formState.email = res.data.email;
    formState.phone = res.data.phone;
    formState.imageList = res.data.screenshot;
    formState.payment_info = res.data.payment_info;
    formState.prize_claim_time = res.data.prize_claim_time;
    formState.process = res.data.process;
    formState.address = res.data.address;
    formState.tracking_number = res.data.tracking_number;
    formState.process_desc = res.data.process_desc;
    formState.rejection_reason = res.data.rejection_reason;

    if (Array.isArray(formState.imageList) && formState.imageList.length > 0) {
      let _index = 0;
      formState.imageList.forEach(item => {
        _index++;
        fileList.value.push({
          uid: _index,
          name: 'image: ' + _index,
          status: 'done',
          url: item
        })
      });
    }
  } else {
    message.error(res.msg);
  }
  return res;
};

onMounted(async () => {
  const route = useRoute();
  const id = route.params.id;
  formState.record_id = id;
  if (typeof id !== 'undefined' && id !== null && id !== '') {
    await queryData({record_id: id});
  }
});

</script>

<style scoped>

</style>
